module.exports = __webpack_public_path__ + "img/footerLogo.6b4c3b12.png";